import React from "react";
import PropTypes from "prop-types";
import "./Objective.scss";

const Objective = ({ label, option, answer, idx }) => {
  console.log(
    "this suppose to be checked",
    (answer?.length ? answer[0] : -1) === idx,
    answer,
    idx
  );
  return (
    <div className="objective-container col-6 mb-4">
      <div className="form-check">
        <input
          className="form-check-input check-primary"
          type="radio"
          checked={Number(answer?.length ? answer[0] : -1) === idx}
          name="objective"
          value={idx}
          id={"radio" + option.toUpperCase()}
        />
        <label
          className="form-check-label label d-flex align-items-center"
          htmlFor={"radio" + option.toUpperCase()}
        >
          <span>
            <span className="bg-primary option-box text-white text-center border rounded-circle me-2 d-flex justify-content-center align-items-center">{`${option.toUpperCase()} `}</span>{" "}
          </span>
          <span> {label}</span>
        </label>
      </div>
    </div>
  );
};

Objective.propTypes = {
  option: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  answer: PropTypes.array,
  idx: PropTypes.number.isRequired,
};

export default Objective;
